/**
 * SoloEditBody — тело правки соло-тарифа (одно поле цены) в мобильном шите.
 */

import {useState} from 'react';

import type {SoloTariff} from '@services/tariffs';

import {SheetFooter} from '../SheetFooter';

type SoloEditBodyProps = {
  solo: SoloTariff;
  onClose: () => void;
  onAskSave: (price: number) => void;
};

export const SoloEditBody = ({solo, onClose, onAskSave}: SoloEditBodyProps) => {
  const [price, setPrice] = useState(String(solo.price));
  const value = Number(price || 0);
  return (
    <>
      <div className="flex-1 overflow-y-auto px-[18px] pb-5 pt-4">
        <label className="text-[12.5px] font-semibold text-skr-ink2">Цена в месяц, сом</label>
        <div className="mt-2 flex items-center gap-2.5">
          <input
            value={price}
            onChange={(e) => setPrice(e.target.value.replace(/\D/g, ''))}
            inputMode="numeric"
            className="h-[50px] flex-1 rounded-xl border border-input bg-card px-[15px] font-mono text-[19px] font-semibold outline-none focus:border-primary"
          />
          <span className="text-[13px] text-muted-foreground">/ мес</span>
        </div>
      </div>
      <SheetFooter disabled={value <= 0} onClose={onClose} onSave={() => onAskSave(value)} />
    </>
  );
};
